module.exports = __webpack_public_path__ + "static/media/git.4a718af7.svg";